<style lang="less" scoped>
.QuestionGr{display: flex;flex-direction: column;}
.table {border-collapse: collapse;width: 100%;margin-top: 10px;}
table {border-collapse: collapse;width: 100%;}
tr,td {border: 1px solid #f5eeee;padding: 5px;border-bottom: 1px solid #f5eeee;}
.tr {width: 100%;height: 50px;}
.left{width: 200px;}
.f_red {color: red;margin-right: 5px;}
.f_hid {color: #ffffff;margin-right: 5px;}
.el-form-item {margin-bottom: 0;}
/deep/.hide .el-upload--picture-card {display: none;}
</style>

<template>
  <div class="QuestionGr" id="QuestionGr">
    <el-form ref="form" :model="form">
      <table>
        <tr>
          <td class="left"><span class="f_red">*</span>咨询内容</td>
          <td class="right">
            <el-form-item>
              <el-input type="textarea" v-model="form.question" :rows="5" style="font-size: 16px"></el-input>
            </el-form-item>
          </td>
        </tr>
        <tr>
          <td class="left"><span class="f_red">*</span>相关图片</td>
          <td class="right">
            <el-upload
              :action="url"
              :limit="1"
              list-type="picture-card"
              :before-upload="beforeUploadPicture"
              :on-preview="handlePictureCardPreview"
              :on-success="onSuccess"
              :on-remove="handleRemovePicture"
              :on-exceed="exceed"
              :on-change="handleEditChange"
              :class="{hide:hideUploadEdit}"
              @mouseover.native="getPhoUrl">
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible">
              <img :src="dialogImageUrl" width="100%" />
            </el-dialog>
          </td>
        </tr>
      </table>
    </el-form>
    <div>
      <el-button type="success" style="width: 100px; margin: 20px auto" @click="release()">发布咨询</el-button>
    </div>
  </div>
</template>

<script>
/**
 * 安进
 * 咨询提问页面
 */
import filters from '../../../method/filter'
export default {
  mixins: [filters],
  components: {},
  data()
  {
    return {
      form: {
        type: 2,
        question: '',
        thumb: ''
      },
      // 类型下拉数据
      options: [
        { value: '选项1', label: '咨询服务', key: 1 },
        { value: '选项2', label: '法律服务', key: 2 }
      ],
      // 上传地址
      url: '',
      // 图片弹框
      dialogVisible: false,
      // 图片预览路径
      dialogImageUrl: '',
      hideUploadEdit: false
    }
  },
  methods: {
    //上传图片
    getPhoUrl()
    {
      let that = this
      window.public.onUploadPicture(that)
    },
    // 发布咨询
    release()
    {
      let obj = {
        cmd: 'add',
        _major: 11,
        _minor: 63,
        retAtt: 1,
        content: this.form.question,
        thumb: this.form.thumb,
        addtime: Date.parse(new Date()) / 1000,
        user: localStorage.getItem('username'),
        type: this.form.type,
        iscomments: 2
      }
      window.post.getPost(obj).then((ret) =>
      {
        if (ret.ret === 1)
          this.$message({message: '添加失败，请检查是否有未填写的内容或者填写不规范', type: 'error', customClass: 'mzindex'})
        else
        {
          this.$emit('cancle')
          this.$message({message: '发布成功', type: 'success', customClass: 'mzindex'})
        }
      })
    },
    //图片上传之前的钩子
    beforeUploadPicture(file)
    {
      let that = this
      window.public.beforeUploadPicture(file, that)
    },
    //上传中
    handlePictureCardPreview(file)
    {
      this.dialogImageUrl = file.url
      this.dialogVisible = true
    },
    //图片上传成功
    onSuccess(response)
    {
      let that = this
      window.public.onSuccess(response, that)
    },
    //上传发生变化（上传或者删除）
    handleEditChange(file, fileList)
    {
      let that = this
      window.public.handleEditChange(file, fileList, that)
    },
    //删除图片
    handleRemovePicture(fileList)
    {
      let that = this
      window.public.handleRemovePicture(fileList, that)
    },
    //超出上传次数
    exceed()
    {
      this.$message({message: '您已上传过了，若需要换一个，请先删除上一个', type: 'error', customClass: 'mzindex'})
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/plugins/app/assembly/zxxx/FL/LegalQuestions.vue